import React, { useEffect, useRef } from "react";
import classnames from "classnames";

import { FONT_WEIGHTS } from "../../constants/misc";
import { CitySearchResultWithCateg } from "../../custom-types/location-search";
import { getRemValue } from "../../methods/getRemValue";
import Search, { SearchProps, SearchRef } from "../search/Search";
import BackBtnIcon from "../../icons/BackBtn.svg";
import Styles from "./SearchFullScreenMobile.module.scss";
import "./SearchFullScreenMobile.scss";

export interface SearchFullScreenMobileProps extends SearchProps<CitySearchResultWithCateg> {
    isVisible: boolean;
    onClickBackBtn: () => void;
    id: string;
    isLoading: boolean;
    onSearch: SearchProps<CitySearchResultWithCateg>["onSearch"];
    onSelectItem: SearchProps<CitySearchResultWithCateg>["onSelectItem"];
    onInputChange?: SearchProps<CitySearchResultWithCateg>["onInputChange"];
    onFocus?: () => void;
    selectedItem?: SearchProps<CitySearchResultWithCateg>["selectedItem"];
    options: SearchProps<CitySearchResultWithCateg>["options"];
    searchText: string;
    labelKey?: SearchProps<CitySearchResultWithCateg>["labelKey"];
    labelText?: string;
    placeholder?: string;
    path?: string;
}

const SearchFullScreenMobile = ({
    isVisible = false,
    onClickBackBtn,
    id,
    isLoading,
    onSearch,
    onSelectItem,
    onInputChange,
    onFocus,
    selectedItem,
    options,
    searchText,
    labelKey,
    labelText,
    placeholder,
    ...props
}: SearchFullScreenMobileProps) => {
    const searchRef = useRef<SearchRef>(null);

    useEffect(() => {
        (async () => {
            if (isVisible) {
                searchRef.current?.focus();
                document.body.style.overflow = "hidden";
                if (window.scrollY !== 0) {
                    window.scrollTo({ left: 0, top: 0, behavior: "auto" });
                }

                (document.querySelector(".sticky-inner-wrapper") as HTMLDivElement)?.classList.add("inactive");
            } else {
                document.body.style.overflow = "unset";
                (document.querySelector(".sticky-inner-wrapper") as HTMLDivElement)?.classList.remove("inactive");
            }
        })();
    }, [isVisible]);

    return isVisible ? (
        <div className={classnames(Styles.container, "search_fullscreen_mobile")}>
            <Search
                ref={searchRef}
                id={id}
                isLoading={isLoading}
                onSearch={onSearch}
                onSelectItem={onSelectItem}
                onInputChange={onInputChange}
                selectedItem={undefined}
                options={options}
                searchText={searchText}
                labelText={labelText}
                labelKey={labelKey}
                onFocus={onFocus}
                // setFocus={1}
                placeholder={placeholder}
                containerStyles={{
                    height: "58px",
                    border: "none",
                    borderBottom: "none",
                    borderRadius: 0
                }}
                inputWrapperStyles={{
                    padding: "0"

                    // marginTop: "12px"
                }}
                inputStyles={{
                    paddingLeft: "16px",
                    fontSize: getRemValue(15),
                    letterSpacing: getRemValue(-0.15),
                    color: "#3B52FF",
                    fontWeight: FONT_WEIGHTS.medium,
                    lineHeight: "18px"
                }}
                prefix={
                    <span onClick={onClickBackBtn}>
                        <BackBtnIcon />
                    </span>
                }
                prefixClassName={Styles.prefix_container}
                setFocus={1}
                minLength={0}
                {...props}
            />
        </div>
    ) : null;
};

export default SearchFullScreenMobile;
